import {FC, useEffect, useState} from "react";
import {Badge, Card, Col, Container, Row} from "react-bootstrap";
import axios from "axios";
import moment from "moment/moment";
import VIAS from './vias.png';
import HEAG from './heagmobilo.png';
import {Trans, useTranslation} from "react-i18next"

type DepartureComponentPros = Record<string, unknown>

const DepartureComponent: FC<DepartureComponentPros> = () => {
    const {t} = useTranslation("departure")

    const [departures, setDepartures] = useState<any>([])

    useEffect(() => {
        axios.get('/api/departure').then(response => setDepartures(response.data))
        let timer: any;
        setTimeout(() => {
            timer = setInterval(() => {
                axios.get('/api/departure').then(response => setDepartures(response.data))
            }, 20000)
        }, 2000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="component">
            <Container>
                <Row>
                    <Col>
                        <Card>
                            <Card.Header><h2>{t("title")}</h2></Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    {departures.map((station: any) =>

                                        <Col xs={6}>
                                            <Card>
                                                <Card.Header className="pt-3">
                                                    <h2><img alt={station.icon} className="d-inline card bg-white p-2" style={{width: "30%"}} src={station.icon === "heag" ? HEAG : VIAS}/> {station.stationName}</h2>
                                                </Card.Header>
                                                <Card.Body>
                                                    {station.departures.map((deps: any, idx: number) =>
                                                        <>
                                                            <p>
                                                                <span className="display-6"><Badge bg="primary">{deps.lineName}</Badge></span><> </>
                                                                <span className="display-7">{moment(deps.expectedDepartureDate).diff(moment(deps.departureDate), 'minutes') > 0 ? <Badge bg="warning">{t("delayed", {count: moment(deps.expectedDepartureDate).diff(moment(deps.departureDate), 'minutes')})}</Badge> : moment(deps.expectedDepartureDate).diff(moment(), 'minutes') < (station.icon === "heag" ? 3 : 8) ? <Badge bg="danger">{t("unreachable")}</Badge> :
                                                                    <Badge bg="success">{t("onTime")}</Badge>}</span>

                                                                <br/><Trans ns="departure" i18nKey="connection" values={{destination: deps.destination, relative: moment(deps.expectedDepartureDate).fromNow(), time: moment(deps.expectedDepartureDate).format("HH:mm")}} components={{strong: <strong/>}}/><br/>
                                                                {moment(deps.expectedDepartureDate).diff(moment(deps.departureDate), 'minutes') > 0 ? <i className="text-muted">{t("originalTime", {time: moment(deps.departureDate).format("HH:mm")})}</i> : <></>}

                                                            </p>
                                                            {idx != station.departures.length - 1 ? <hr/> : <></>}</>
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )

}

export default DepartureComponent
